import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import favoriteDone from "../../assets/images/dasboard/favorite-done.png";
import favoritePending from "../../assets/images/dasboard/favorite-pending.png";
import { useDispatch } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";
import {
  POST_MEAL_LOG_ENDPOINT,
  PUT_MEAL_SELF_FAV_ENDPOINT,
} from "../../config/ApisCollection";
import axios from "axios";

export default function MealView({ mealChoosedData }) {
  const dispatch = useDispatch();
  const accessToken = secureLocalStorage.getItem("accessToken");
  const [tabType, setTabType] = useState("ing");
  const [mealData, setMealData] = useState(mealChoosedData);

  const menuOption = [];
  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(31));
  };

  const postMealLog = async (receipeid) => {
    const date = "2024-08-08";
    const day = "Thursday";
    const dateDayString = `${date} ${day}`;

    // Encode to Base64
    const encoded = btoa(dateDayString);

    const post_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Date-Day": encoded,
        "Content-Type": "application/json",
      },
    };
    // console.log(post_body);
    const response = await axios.put(
      `${POST_MEAL_LOG_ENDPOINT}/${receipeid}/done`,
      {},
      post_body
    );
    if (response && response.status && response.status === 200) {
      // Create a copy of the current state
      const updatedMealData = {
        ...mealData,
      };
      // Toggle the isFavorite value
      updatedMealData.isAction = !updatedMealData.isAction;
      // Update the state with the modified data
      setMealData(updatedMealData);
    }
  };

  const postMealFavorite = async (receipeid) => {
    const date = "2024-08-08";
    const day = "Thursday";
    const dateDayString = `${date} ${day}`;

    // Encode to Base64
    const encoded = btoa(dateDayString);

    const post_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Date-Day": encoded,
        "Content-Type": "application/json",
      },
    };
    // console.log(post_body);
    const response = await axios.put(
      `${PUT_MEAL_SELF_FAV_ENDPOINT}/${receipeid}/favorite`,
      {},
      post_body
    );
    if (response && response.status && response.status === 200) {
      // Create a copy of the current state
      const updatedMealData = {
        ...mealData,
      };
      // Toggle the isFavorite value
      updatedMealData.isFavorite = !updatedMealData.isFavorite;
      // Update the state with the modified data
      setMealData(updatedMealData);
    }
  };

  useEffect(() => {
    setMealData(mealChoosedData);
  }, [mealChoosedData]);
  // console.log(mealData.isAction);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <div className="w-full flex justify-between">
          <div className="w-full flex">
            <SideBarBack
              className="bg-transparent"
              handleCloseDrawer={handleCloseDrawer}
            />
            <b className="font-2xl">Recipe</b>
          </div>
          <div
            onClick={() => {
              postMealFavorite(mealData?.id);
            }}
          >
            <img
              src={
                mealData?.isFavorite === false ? favoritePending : favoriteDone
              }
            />
          </div>
        </div>
      </div>
      <div className="flex justify-center flex-col gap-2 mt-12 w-11/12 mx-auto pb-10">
        <div className="border border-[#23B3F1] bg-[#E2F6FF] rounded-2xl px-3 py-4 text-center">
          <img
            src={mealData?.picture || mealData?.thumbnail}
            className="w-full rounded-full h-1/2 shadow-lg shadow-[#00000082]"
            height={285}
            width={285}
          />
        </div>
        <div
          className={`flex  justify-center py-2.5 px-3 items-center gap-3 -mt-[25px] rounded-2xl w-9/12 mx-auto shadow-lg shadow-[#eee] ${
            mealData?.isAction !== "pending"
              ? "border border-[#ff994f] bg-[#ff994f]"
              : " cursor-pointer bg-white"
          }`}
        >
          <p
            className="text-xs"
            onClick={() => {
              postMealLog(mealData?.id);
            }}
          >
            <i
              className={
                mealData?.isAction === "pending"
                  ? "fa fa-clock-o"
                  : "fa fa-check"
              }
            ></i>{" "}
            {mealData?.isAction === "pending"
              ? "Tap to log this meal"
              : "You have logged this meal"}
          </p>
        </div>

        <h1 className="text-capitalize text-xl font-semibold mt-5">
          {mealData?.dietTitle}
        </h1>

        <div className="fasweekdes spacetop ">
          <div className="nutbotmbox">
            <div className="nutbotmbox1">
              <div className="nutbotmbox1tex">
                <p>carbs</p>
              </div>
            </div>
            <div className="tabroe1">
              <div className="nutbotmtex mb-2">
                <p>25</p>
              </div>
              <div className="modesutit1">
                <p>gm</p>
              </div>
              <div className="nutbarnotfill">
                <div className="nutbarfill" />
              </div>
            </div>
          </div>
          <div
            className="nutbotmbox"
            style={{
              border: "2px solid rgba(88, 85, 158, 0.30)",
            }}
          >
            <div
              className="nutbotmbox1"
              style={{
                background: "rgba(88, 85, 158, 0.10)",
              }}
            >
              <div className="nutbotmbox1tex" style={{ color: "#58559E" }}>
                <p>proteins</p>
              </div>
            </div>
            <div className="tabroe1">
              <div className="nutbotmtex mb-2">
                <p>11.8</p>
              </div>
              <div className="modesutit1">
                <p>gm</p>
              </div>
              <div className="nutbarnotfill">
                <div className="nutbarfill" style={{ background: "#58559E" }} />
              </div>
            </div>
          </div>
          <div
            className="nutbotmbox"
            style={{
              border: "2px solid rgba(255, 153, 80, 0.30)",
            }}
          >
            <div
              className="nutbotmbox1"
              style={{
                background: "rgba(255, 153, 80, 0.10)",
              }}
            >
              <div className="nutbotmbox1tex" style={{ color: "#FF9950" }}>
                <p>fats</p>
              </div>
            </div>
            <div className="tabroe1">
              <div className="nutbotmtex mb-2">
                <p>22</p>
              </div>
              <div className="modesutit1">
                <p>gm</p>
              </div>
              <div className="nutbarnotfill">
                <div className="nutbarfill" style={{ background: "#FF9950" }} />
              </div>
            </div>
          </div>
        </div>

        <div className="border mt-5 border-[#23B3F1] bg-[#fff] rounded-3xl px-3 py-4 text-justify">
          <div className="flex justify-center gap-5">
            <div
              dangerouslySetInnerHTML={{
                __html: mealData?.dietDescription,
              }}
              className="text-[12px]"
            />
          </div>
          <div className="flex gap-3 mt-5">
            <div
              className={`${
                tabType === "ing"
                  ? "bg-[#FF9950] text-white"
                  : "border border-[#ff99504d]"
              } flex gap-2 rounded items-cente  px-2 py-1`}
              onClick={() => {
                setTabType("ing");
              }}
            >
              {/* <div className="w-2 h-2 rounded-full bg-[#FFEDE0]"></div> */}
              <span className="text-[10px] font-semibold">Ingredients</span>
            </div>
            <div
              className={`${
                tabType === "ins"
                  ? "bg-[#FF9950] text-white"
                  : "border border-[#ff99504d]"
              } flex gap-2 rounded items-cente  px-2 py-1`}
              onClick={() => {
                setTabType("ins");
              }}
            >
              {/* <div className="w-2 h-2 rounded-full bg-[#FF9950]"></div> */}
              <span className="text-[10px] font-semibold">Instructions</span>
            </div>
            <div
              className={`${
                tabType === "nut"
                  ? "bg-[#FF9950] text-white"
                  : "border border-[#ff99504d]"
              } flex gap-2 rounded items-cente  px-2 py-1`}
              onClick={() => {
                setTabType("nut");
              }}
            >
              {/* <div className="w-2 h-2 rounded-full bg-[#FF9950]"></div> */}
              <span className="text-[10px] font-semibold">Nutrition</span>
            </div>
          </div>

          <div className=" bg-white justify-center py-2.5 px-3 items-center gap-3 mt-3 rounded-2xl w-full mx-auto">
            {tabType === "ins" ? (
              <>
                {" "}
                <p className="text-left text-sm font-semibold text-[#000] ">
                  Treat days
                </p>
                <p className="text-left text-[11px] font-medium text-[#000] ">
                  On those days you take a break from fasting. Yay!
                </p>
              </>
            ) : tabType === "nut" ? (
              <>
                <p className="text-left text-[10px] font-normal text-[#18192B] mt-3">
                  We don’t recommend choosing more than 2 treat days.
                </p>
              </>
            ) : (
              <div className="flex justify-center gap-2 flex-col mt-3">
                {mealData?.dietIngredients?.map((item, index) => (
                  <div
                    key={index}
                    className="cursor-pointer px-2.5 py-2.5 flex justify-center items-center rounded-lg bg-[#FFEDE0] text-[#FE7701] text-left"
                  >
                    <p className="text-xs text-capitalize text-[8px]">
                      {item.title}
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
